export default "__VITE_ASSET__FsFsxGoX__"